import React from 'react';
import './App.css';
import DoctorForm from './page/DoctorForm/DoctorForm';
import DoctorHomeConsultationForm from './page/DoctorHomeConsultationForm/DoctorHomeConsultationForm';
import NurseryForm from './page/NurseryForm/NurseryForm';
import PhysiotherapyForm from './page/PhysiotherapyForm/PhysiotherapyForm';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import SupportContact from './components/supportContact/SupportContact';
import DoctorData from './page/DoctorData/DoctorData';
import DoctorDataView from './page/DoctorDataView/DoctorDataView';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import CustomModal from './components/modal/Modal';
import PharmacyForm from './page/pharmacyForm/PharmacyFrom';
import Introduction from './page/indroPage/IntroPage';
import PharmacyData from './page/pharmacyData/PharmacyData';
import PharmacyImport from './page/PharmacyImport/PharmacyImport';
import SpecialtiesManagement from './page/SpecialtiesManagement/SpecialtiesManagement';
import { useJsApiLoader } from '@react-google-maps/api';
import { CONSULTATION_REGISTRATION } from './config/appConfig';

const googleLibraries = ["places", "marker"];

function App() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: googleLibraries,
  });

  // The Router wraps the header too: it shows the partner logo on the consultation link routes.
  return (
    <Router>
      <Header />
        <Routes>
          <Route path="/" element={<Introduction />} />
          <Route path="/admin-registered" element={<DoctorData />} />
          <Route path="/admin-view-registered" element={<DoctorDataView />} />
          <Route path="/pharmacy-data" element={<PharmacyData />} />
          <Route path="/doctor-dash" element={<Introduction fromPage="doctor" />} />
          <Route path="/doctor-home-consultation-dash" element={<Introduction fromPage="doctor-home-consultation" />} />
          {/* <Route path="/doctor-dash" element={<Introduction />} /> */}
          {/* <Route path="/pharmacy-dash" element={<Introduction />} /> */}
          <Route path="/pharmacy-dash" element={<Introduction fromPage="pharmacy" />} />
          <Route path="/nurse-form-dash" element={<Introduction fromPage="nurse" />} />
          <Route path="/physiotherapy-form-dash" element={<Introduction fromPage="physiotherapy" />} />
          <Route path="/doctor-form" element={<DoctorForm />} />
          <Route path="/doctor-home-consultation-form" element={<DoctorHomeConsultationForm />} />
          <Route path="/nurse-form" element={<NurseryForm />} />
          <Route path="/physiotherapy-form" element={<PhysiotherapyForm />} />
          <Route path="/pharmacy-form" element={<PharmacyForm />} />
          <Route path="/pharmacy-import" element={<PharmacyImport />} />
          <Route path="/specialties-management" element={<SpecialtiesManagement />} />
          {/* Tiryaq Professional consultation registration link: forms without the intro slides,
              and a separate view of the registrations it received. */}
          <Route path={`${CONSULTATION_REGISTRATION.ROUTE_PREFIX}/doctor-form`} element={<DoctorForm consultationLink />} />
          <Route path={`${CONSULTATION_REGISTRATION.ROUTE_PREFIX}/doctor-home-consultation-form`} element={<DoctorHomeConsultationForm consultationLink />} />
          <Route path="/admin-consultation-registered" element={<DoctorData registrationSource={CONSULTATION_REGISTRATION.SOURCE} />} />
          <Route path="/admin-view-consultation-registered" element={<DoctorData registrationSource={CONSULTATION_REGISTRATION.SOURCE} readOnly />} />
          {/* <Route path="/doctor-form" element={<DoctorForm />} /> */}
        </Routes>
      {/* WhatsApp support card on every page except the intro slides (INTRO_ROUTES in appConfig). */}
      <SupportContact />
      <Footer />
      <CustomModal />
    </Router>
  );
}

export default App;
